import SettingsCard from "./ui/SettingsCard";

export default function DisplaySection() {
  return (
    <SettingsCard title="Theme">
      <p>Switch between Light and Dark mode.</p>
    </SettingsCard>
  );
}